import Vue from 'vue'
// import Vuex from 'vuex'
import Vuex, { StoreOptions } from 'vuex'
import { profileModule } from './modules/profile/index';

Vue.use(Vuex)

const store: StoreOptions<any>= {
  state: {
      version: '1.0.0' // a simple property
  },
  modules: {
      profileModule
  }
};

export default new Vuex.Store(store);